import { ExtendedTab, GlobalMyAccountToolsRoutes } from '@hdms/shared/common-types';

import { AccessService } from '../services/access.service';
import { NavigationTabId } from '../types/navigation-tab-id';

interface EnabledExtendedTab extends ExtendedTab {
  enabled?: (a: AccessService) => boolean;
}

export const staticTabList: EnabledExtendedTab[] = [
  { id: NavigationTabId.GENERAL_TOOLS, url: GlobalMyAccountToolsRoutes.GENERAL_TOOLS, label: 'generalTools' },
  { id: NavigationTabId.REPAIR, url: GlobalMyAccountToolsRoutes.REPAIR, label: 'repairTools' }
];

const tabList: EnabledExtendedTab[] = [
  ...staticTabList,
  {
    id: NavigationTabId.REPAIR_TRACKING,
    url: GlobalMyAccountToolsRoutes.REPAIR_TRACKING,
    label: 'repairTracking',
    enabled: a => a.isRepairTrackingEnabled()
  },
  {
    id: NavigationTabId.LOST_STOLEN,
    url: GlobalMyAccountToolsRoutes.LOST_STOLEN,
    label: 'lostStolen',
    enabled: a => a.isLostStolenEnabled()
  },
  {
    id: NavigationTabId.RETURN,
    url: GlobalMyAccountToolsRoutes.RETURN,
    label: 'returnTools',
    enabled: a => a.isReturnEnabled()
  },
  {
    id: NavigationTabId.EXCHANGE,
    url: GlobalMyAccountToolsRoutes.FLEET_EXCHANGE,
    label: 'fleetExchange',
    enabled: a => a.isFleetExchangeEnabled()
  },
  {
    id: NavigationTabId.REORDER_LABELS,
    url: GlobalMyAccountToolsRoutes.REORDER_LABELS,
    label: 'reorderLabels',
    enabled: a => a.isReorderLabelsEnabled()
  },
  {
    id: NavigationTabId.COST_CENTER,
    url: GlobalMyAccountToolsRoutes.COST_CENTER_LIST,
    label: 'costCenter',
    enabled: a => a.isCostCenterEnabled()
  },
  {
    id: NavigationTabId.LOAN,
    url: GlobalMyAccountToolsRoutes.LOAN,
    label: 'loanTools',
    enabled: a => a.isLoanEnabled()
  },
  {
    id: NavigationTabId.PEAK,
    url: GlobalMyAccountToolsRoutes.PEAK,
    label: 'peakTools',
    enabled: a => a.isPeakEnabled()
  },
  {
    id: NavigationTabId.CIRCULARITY_REPORTS,
    url: GlobalMyAccountToolsRoutes.CIRCULARITY_REPORTS,
    label: 'circularityReports',
    enabled: a => a.isCircularityReportsEnabled()
  }
];

export function getNavigationTabs(accessService?: AccessService, tabs = tabList): ExtendedTab[] {
  return tabs
    .filter(tab => !accessService || !tab.enabled || tab.enabled(accessService))
    .map(({ id, label, url }) => ({
      id,
      label,
      url: `/${GlobalMyAccountToolsRoutes.BASE}/${url}`
    }));
}

export function getTabInfo(navigationTabId: string): string {
  return navigationTabId.replace(/link|-/g, ' ').trim();
}
